// Copyright (C) 2022 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';
import React from 'react';
import Layout from 'antd/lib/layout';
import ThemeToggle from 'components/theme-toggle/theme-toggle';
import BrandLogo from 'components/brand-logo/brand-logo';

interface SignInLayoutComponentProps {
    children: JSX.Element | JSX.Element[];
}

interface Sizes {
    xs?: { span: number };
    sm?: { span: number };
    md?: { span: number };
    lg?: { span: number };
    xl?: { span: number };
    xxl?: { span: number };
}

interface FormSizes {
    wrapper: Sizes;
    form: Sizes;
}

// The card's width is set in styles.scss; the pages' grid columns just fill it.
const fullWidth: Sizes = { xs: { span: 24 } };
export const formSizes: FormSizes = {
    wrapper: fullWidth,
    form: fullWidth,
};

function SignInLayout(props: SignInLayoutComponentProps): JSX.Element {
    const { children } = props;

    return (
        <Layout className='cvat-signing-layout'>
            <ThemeToggle className='cvat-signing-theme-toggle' />
            <div className='cvat-signing-content'>
                <div className='cvat-signing-brand'>
                    <BrandLogo size='large' />
                </div>
                {children}
            </div>
        </Layout>
    );
}

export default SignInLayout;
